import {
    Tickets,
    TicketType,
    TapeChangeType,
} from '@/modules/shared/shared/domain/constants/constants';
import * as FORM_INTERFACE from '../interfaces/accessTicket.interface';
import * as DB_INTERFACE from '../interfaces/DB.interface';
import * as PDT_INTERFACE from '../interfaces/PDT.interface';

export function modifyFormToDB(
    accessTicket: FORM_INTERFACE.accessTicketInterface,
    contact: any,
    headquartersName: string,
    reasonsFormValues: FORM_INTERFACE.reasonsInterface[],
    oldPDT: PDT_INTERFACE.PDTInterface,
) {
    const mappedAccessTicket: DB_INTERFACE.accessTicketModificationInterface = {
        id: oldPDT.id,
        name: oldPDT.name,
        criticality: oldPDT.criticality,
        media: oldPDT.media,
        priority: oldPDT.priority,
        group: oldPDT.group,
        ticketType: Tickets.ACCESS.id,
        team: oldPDT.team,
        userCreator: oldPDT.userCreator,
        contactId: oldPDT.contactId,
        creationDate: oldPDT.creationDate,
        closingDate: oldPDT.closingDate,
        startDate:
            accessTicket.generalInformation.fromDateVal +
            ' ' +
            accessTicket.generalInformation.fromTimeVal,
        endDate:
            accessTicket.generalInformation.toDateVal +
            ' ' +
            accessTicket.generalInformation.toTimeVal,
        customerId: oldPDT.customerId,
        customerCategory: contact.customer.category.id,
        typing: {
            id: oldPDT.typing.id,
        },
        listChanges: getListChanges(
            [oldPDT.startDate.split('T')[0], accessTicket.generalInformation.fromDateVal],
            [oldPDT.endDate.split('T')[0], accessTicket.generalInformation.toDateVal],
            [oldPDT.customerCategory, contact.customer.category.id],
        ),
        accessPermission: {
            date: setRuleDate() + ' ' + setRuleHour(),
            startDate:
                accessTicket.generalInformation.fromDateVal +
                ' ' +
                accessTicket.generalInformation.fromTimeVal,
            endDate:
                accessTicket.generalInformation.toDateVal +
                ' ' +
                accessTicket.generalInformation.toTimeVal,
            emergency: accessTicket.generalInformation.emergencyChangeReason != '',
            ticketId: oldPDT.id,
            emergencyComment: accessTicket.generalInformation.emergencyChangeReason,
            serviceInterruption: accessTicket.generalInformation.requiresInterruption,
            dataCenter: accessTicket.generalInformation.headquarters,
            //accessType: accessTicket.generalInformation.accessReason,
            accessPermissionId: oldPDT.accessPermission.id,
            accessPermissionMotives: getAllMotives(
                accessTicket.generalInformation.accessMotivesDataCenter,
                accessTicket.generalInformation.accessMotivesJob,
                accessTicket.generalInformation.accessMotivesChange,
                accessTicket.generalInformation.accessReasons,
                accessTicket.generalInformation.otherMotiveDataCenter,
                accessTicket.generalInformation.otherMotiveJob,
                accessTicket.generalInformation.otherMotiveChange,
                reasonsFormValues,
            ),
            accessContacts: getAccessContacts(
                accessTicket.involvedPeople,
                accessTicket.contactTypeID,
            ),
            accessPermissionEquipments: getAccessEquipments(
                accessTicket.hardwareTransfer,
                headquartersName,
            ),
            serviceOrder: accessTicket.generalInformation.orderNumber,
            tasks: getTasks(accessTicket.tasks),
            vehicles: getVehicles(accessTicket.accessCars),
        },
        customer: {
            id: contact.customer.id,
            name: contact.customer.name,
            category: {
                id: contact.customer.category.id,
            },
            contact: {
                id: contact.id,
                name: contact.name,
                lastName: contact.lastName,
                identification: contact.ci,
                phone: contact.phone,
            },
        },
    };
    return mappedAccessTicket;
}

export function createFormToDB(
    accessTicket: FORM_INTERFACE.accessTicketInterface,
    contact: any,
    reasonsFormValues: FORM_INTERFACE.reasonsInterface[],
    headquartersName: string,
) {
    const mappedAccessTicket: DB_INTERFACE.accessTicketInterface = {
        ticketType: {
            id: Tickets.ACCESS.id,
            name: Tickets.ACCESS.alias,
        },
        startDate:
            accessTicket.generalInformation.fromDateVal +
            ' ' +
            accessTicket.generalInformation.fromTimeVal +
            ':00',
        endDate:
            accessTicket.generalInformation.toDateVal +
            ' ' +
            accessTicket.generalInformation.toTimeVal +
            ':00',
        description: accessTicket.generalInformation.additionalComment,
        accessPermission: {
            date: setRuleDate() + ' ' + setRuleHour(),
            startDate:
                accessTicket.generalInformation.fromDateVal +
                ' ' +
                accessTicket.generalInformation.fromTimeVal +
                ':00',
            endDate:
                accessTicket.generalInformation.toDateVal +
                ' ' +
                accessTicket.generalInformation.toTimeVal +
                ':00',
            emergency: accessTicket.generalInformation.emergencyChangeReason != '',
            emergencyComment: accessTicket.generalInformation.emergencyChangeReason,
            serviceOrder: accessTicket.generalInformation.orderNumber,
            serviceInterruption: accessTicket.generalInformation.requiresInterruption,
            dataCenter: accessTicket.generalInformation.headquarters,
            accessType: getAllReasons(
                accessTicket.generalInformation.accessReasons,
                reasonsFormValues,
            ),
            accessPermissionMotives: getAllMotives(
                accessTicket.generalInformation.accessMotivesDataCenter,
                accessTicket.generalInformation.accessMotivesJob,
                accessTicket.generalInformation.accessMotivesChange,
                accessTicket.generalInformation.accessReasons,
                accessTicket.generalInformation.otherMotiveDataCenter,
                accessTicket.generalInformation.otherMotiveJob,
                accessTicket.generalInformation.otherMotiveChange,
                reasonsFormValues,
            ),
            accessContacts: getAccessContacts(
                accessTicket.involvedPeople,
                accessTicket.contactTypeID,
            ),
            accessPermissionEquipments: getAccessEquipments(
                accessTicket.hardwareTransfer,
                headquartersName,
            ),
            tasks: getTasks(accessTicket.tasks),
            vehicles: getVehicles(accessTicket.accessCars),
        },
        customer: {
            id: contact.customer.id,
            name: contact.customer.name,
            category: {
                id: contact.customer.category.id,
            },
            contact: {
                id: contact.id,
                name: contact.name,
                lastName: contact.lastName,
                identification: contact.ci,
                phone: contact.phone,
                email: contact.email,
            },
        },
    };
    return mappedAccessTicket;
}

function getVehicles(accessCars: FORM_INTERFACE.accessCarsInterface[]) {
    let vehicles: DB_INTERFACE.vehiclesInterface[] = Array();
    accessCars.forEach(car => {
        vehicles.push({
            licensePlate: car.numberPlate,
            model: car.model,
            brand: car.brand,
        });
    });
    return vehicles;
}

function getTasks(accessTasks: FORM_INTERFACE.tasksInterface[]) {
    let tasks: DB_INTERFACE.tasksInterface[] = Array();
    accessTasks.forEach(task => {
        tasks.push({
            name: task.description,
            taskType: {
                id: task.person,
            },
        });
    });
    return tasks;
}

function getAccessEquipments(
    hardwareTransfer: FORM_INTERFACE.hardwareTransferInterface[],
    headquartersName: string,
) {
    let equipments: DB_INTERFACE.accessPermissionEquipmentsInterface[] = Array();
    hardwareTransfer.forEach(hardwareUnit => {
        let item: DB_INTERFACE.accessPermissionEquipmentsInterface = {} as DB_INTERFACE.accessPermissionEquipmentsInterface;
        item.destination = hardwareUnit.transferInformation.destination;
        item.departureMotive = hardwareUnit.transferInformation.motive;
        item.movementType = {
            id: hardwareUnit.transferInformation.movementType.id,
            name: hardwareUnit.transferInformation.movementType.name,
        };
        if (hardwareUnit.transferInformation.reasonForTransfer.id == undefined) {
            item.accessEquipmentDepartureType = undefined;
        } else {
            item.accessEquipmentDepartureType = {
                id: hardwareUnit.transferInformation.reasonForTransfer.id,
                name: hardwareUnit.transferInformation.reasonForTransfer.name,
            };
        }
        if (hardwareUnit.transferInformation.lengthOfTransfer == undefined) {
            item.accessEquipmentDeparturePeriodType = undefined;
        } else {
            item.accessEquipmentDeparturePeriodType = {
                id: hardwareUnit.transferInformation.lengthOfTransfer,
                name:
                    hardwareUnit.transferInformation.lengthOfTransfer === 1
                        ? 'Salida temporal'
                        : hardwareUnit.transferInformation.lengthOfTransfer === 2
                        ? 'Salida permanente'
                        : undefined,
            };
        }
        item.equipment = {
            serial: hardwareUnit.hardware.serialNumber,
            name: hardwareUnit.hardware.name,
            model: hardwareUnit.hardware.model,
            brand: hardwareUnit.hardware.brand,
            measureUnit: hardwareUnit.hardware.measureUnit,
            voltage: hardwareUnit.hardware.nominalVoltage.replace(',', '.'),
            consumption: hardwareUnit.hardware.nominalConsumption.replace(',', '.'),
            location: headquartersName,
        };
        equipments.push(item);
    });
    return equipments;
}

function getAccessContacts(
    involvedPeople: FORM_INTERFACE.involvedPeopleInterface,
    contactTypeID: FORM_INTERFACE.contactTypeIdInterface,
) {
    let contacts: DB_INTERFACE.accessContactsInterface[] = Array();
    for (const key in involvedPeople) {
        if (involvedPeople.hasOwnProperty(key)) {
            involvedPeople[key].forEach((person, index) => {
                contacts.push({
                    contactId: person.contactId ? person.contactId : null,
                    name: person.firstName,
                    lastName: person.lastName,
                    identification: person.hasOwnProperty('idNumber') ? person.idNumber : '',
                    phone: person.hasOwnProperty('telephoneNumber') ? person.telephoneNumber : '',
                    email: person.hasOwnProperty('email') ? person.email : '',
                    company: person.hasOwnProperty('company') ? person.company : '',
                    contactDetails: getContactDetails(index, key, contactTypeID),
                });
            });
        }
    }
    return contacts;
}

function getContactDetails(
    index: number,
    key: string,
    contactTypeID: FORM_INTERFACE.contactTypeIdInterface,
) {
    let contactDetails: {
        contactType: {
            id: number;
        };
    }[] = Array();
    if (index == 0 && key == 'authorizedPeople') {
        contactDetails.push({
            contactType: {
                id: contactTypeID['responsiblePerson'],
            },
        });
    }
    contactDetails.push({
        contactType: {
            id: contactTypeID[key],
        },
    });
    return contactDetails;
}

function getAllReasons(
    accessReasons: number[],
    reasonsFormValues: FORM_INTERFACE.reasonsInterface[],
) {
    let allReasons: DB_INTERFACE.idNameInterface[] = Array();
    accessReasons.forEach(reason => {
        allReasons.push(getReason(reason, reasonsFormValues));
    });
    return allReasons;
}

function getReason(accessReason: number, reasonsFormValues: FORM_INTERFACE.reasonsInterface[]) {
    let reason: DB_INTERFACE.idNameInterface = {} as DB_INTERFACE.idNameInterface;
    let reasonName: string = '';
    reasonsFormValues.forEach(reasonFormValue => {
        if (reasonFormValue.value == accessReason) {
            reasonName = reasonFormValue.text;
        }
    });
    reason = {
        id: accessReason,
        name: reasonName,
    };
    return reason;
}

function getAllMotives(
    accessMotivesDataCenter: number[],
    accessMotivesJob: number[],
    accessMotivesChange: number[],
    accessReasons: number[],
    otherMotiveDataCenter: string,
    otherMotiveJob: string,
    otherMotiveChange: string,
    reasonsFormValues: FORM_INTERFACE.reasonsInterface[],
) {
    let allMotives: DB_INTERFACE.accessPermissionMotivesInterface[] = Array();
    accessReasons.forEach(reason => {
        let motives: DB_INTERFACE.accessPermissionMotivesInterface[] = Array();
        switch (reason) {
            case 1:
                motives = getMotives(
                    accessMotivesDataCenter,
                    reason,
                    otherMotiveDataCenter,
                    reasonsFormValues,
                );
                break;
            case 2:
                motives = getMotives(accessMotivesJob, reason, otherMotiveJob, reasonsFormValues);
                break;
            case 3:
                motives = getMotives(
                    accessMotivesChange,
                    reason,
                    otherMotiveChange,
                    reasonsFormValues,
                );
                break;

            default:
                break;
        }
        allMotives.push(...motives);
    });
    return allMotives;
}

function getMotives(
    accessMotives: number[],
    accessReason: number,
    otherMotive: string,
    reasonsFormValues: FORM_INTERFACE.reasonsInterface[],
) {
    let motives: DB_INTERFACE.accessPermissionMotivesInterface[] = Array();
    accessMotives.forEach(motive => {
        let motiveName: string = '';
        let reasonMotiveId: number = 0;
        reasonsFormValues.forEach(reasonFormValue => {
            reasonFormValue.motives.forEach(motiveFormValue => {
                if (motiveFormValue.value == motive && reasonFormValue.value == accessReason) {
                    motiveName = motiveFormValue.text;
                    reasonMotiveId = motiveFormValue.reasonMotiveId;
                }
            });
        });
        motives.push({
            accessMotiveDescription: motive == 20 ? otherMotive : undefined,
            accessPermissionTypeMotive: {
                id: reasonMotiveId,
                accessMotive: {
                    id: motive,
                    name: motiveName,
                },
            },
        });
    });
    return motives;
}

function getListChanges(startDate: string[], endDate: string[], category: number[]) {
    let listChanges: string = '';
    if (startDate[0].localeCompare(startDate[1]) != 0) {
        listChanges += 'Fecha Inicio ; ' + startDate[0] + ' ; ' + startDate[1];
    }
    if (endDate[0].localeCompare(endDate[1]) != 0) {
        listChanges += listChanges.length > 0 ? ' | ' : '';
        listChanges += 'Fecha Fin ; ' + endDate[0] + ' ; ' + endDate[1];
    }
    if (category[0] != category[1]) {
        listChanges += listChanges.length > 0 ? ' | ' : '';
        listChanges += 'Categoría ; ' + category[0] + ' ; ' + category[1];
    }
    listChanges += listChanges.length > 0 ? ' ' : '';
    return listChanges;
}

function setRuleDate() {
    let ruleDate: Date = new Date();
    return ruleDate.getFullYear() + '-' + (ruleDate.getMonth() + 1) + '-' + ruleDate.getDate();
}

function setRuleHour() {
    let ruleDate: Date = new Date();
    return ruleDate.getHours() + ':' + ruleDate.getMinutes() + ':' + ruleDate.getSeconds();
}

export function createRemoteAssistanceFromToDB(requirementTicket, contact) {
    return {
        ticketType: {
            id: Tickets.REQUIREMENT.id,
            name: 'remote-assistance',
        },
        typing: {
            id: requirementTicket.generalInformation.subject.id,
            name: `${requirementTicket.generalInformation.subCategory.name} - ${requirementTicket.generalInformation.subject.name}`,
        },
        customer: {
            id: contact.customer.id,
            name: contact.customer.name,
            category: {
                id: contact.customer.category.id,
            },
            contact: {
                id: requirementTicket.generalInformation.contactId,
                name: requirementTicket.generalInformation.firstName,
                lastName: requirementTicket.generalInformation.lastName,
                email: contact.email,
            },
        },
        description: requirementTicket.generalInformation.description,
    };
}
